import React, { useState } from 'react';
import { generatePath } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, BUTTON_TYPES } from '_atoms';
import history from 'helpers/history';
import { ACTIONS, Can, UI } from 'permission';
import { ROUTES } from 'router/constants';
import type { SelectOption } from '_atoms/Select/types';
import { PopupSelectPromotionRequestJob } from '../PopupSelectPromotionRequestJob';

interface CreatePromotionRequestButtonProps {
  jobId?: string;
}

export const CreatePromotionRequestButton: React.FC<CreatePromotionRequestButtonProps> = ({ jobId }) => {
  const { t } = useTranslation();
  const [jobPopupOpen, setJobPopupOpen] = useState(false);

  const navigateToCreation = (id: string) => history.push(generatePath(ROUTES.JOBS_PROMOTION_REQUEST_CREATE, { id }));

  const onClick = () => {
    if (jobId) {
      navigateToCreation(jobId);
    } else {
      setJobPopupOpen(true);
    }
  };

  const onJobSelected = (job: SelectOption) => {
    navigateToCreation(String(job.value));
  };

  return (
    <Can I={ACTIONS.CREATE} a={UI.PROMOTION_REQUEST_CREATE}>
      <>
        <Button type={BUTTON_TYPES.PRIMARY} onClick={onClick}>
          {t('translation:job_promotion_requests_tab.button_create')}
        </Button>
        {!jobId && (
          <PopupSelectPromotionRequestJob
            open={jobPopupOpen}
            onClose={() => setJobPopupOpen(false)}
            onConfirm={onJobSelected}
          />
        )}
      </>
    </Can>
  );
};
